import { once } from 'lodash'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { paidEvent } from 'tag-manager/paid'
import { CheckoutSuccess as View } from 'ui-components'

export const CheckoutSuccess = () => {
  const [open, setOpen] = useState(true)
  const router = useRouter()

  const workspaceId = router?.query?.workspaceId as string | undefined

  const handleClose = () => {
    setOpen(false)
  }

  const checkout = router.query?.checkout as string | undefined

  useEffect(() => {
    if (checkout !== 'success') return
    if (!workspaceId) return

    const plan = getPlan(workspaceId)
    const billingInterval = getBillingInterval(workspaceId)

    if (!plan || !billingInterval) return

    const paid = once(paidEvent)
    paid(plan, billingInterval)

    removePlan(workspaceId)
    removeBillingInterval(workspaceId)
  }, [checkout, workspaceId])

  if (checkout !== 'success') return null

  return (
    <View
      open={open}
      onClose={handleClose}
    />
  )
}

const getPlanKey = (workspaceId) => `${workspaceId}:stripe:plan`
const getBillingIntervalKey = (workspaceId) =>
  `${workspaceId}:stripe:billingInterval`

export const setPlan = (workspaceId: string, plan: string) => {
  localStorage.setItem(getPlanKey(workspaceId), plan)
}

export const setBillingInterval = (workspaceId: string, interval: string) => {
  localStorage.setItem(getBillingIntervalKey(workspaceId), interval)
}

const getPlan = (workspaceId: string) => {
  return localStorage.getItem(getPlanKey(workspaceId))
}

const getBillingInterval = (workspaceId: string) => {
  return localStorage.getItem(getBillingIntervalKey(workspaceId))
}

const removePlan = (workspaceId: string) => {
  localStorage.removeItem(getPlanKey(workspaceId))
}

const removeBillingInterval = (workspaceId: string) => {
  localStorage.removeItem(getBillingIntervalKey(workspaceId))
}
